<template>
  <!-- 财务报表 newFinanceReport-->
  <div class="home">
    <span style="background: #fff; display: block;padding: 10px;">
      <span class="search">
        <span>用户名：<el-input v-model="params.ownerName" placeholder="用户名" style="width: 120px;"></el-input></span>
        <span>手机号：<el-input v-model="params.mobile" placeholder="手机号" style="width: 120px;"></el-input></span>
        <span>编号：<el-input v-model="params.rfid" placeholder="编号" style="width: 120px;"></el-input></span>

        <span>
          日期:
          <el-date-picker v-model="params.nowTime" :type="params.queryType=='DAY'?'date':'month'"
            :picker-options="pickerOptions" value-format="timestamp" placeholder="选择日期">
          </el-date-picker>
        </span>
        <el-button icon="el-icon-search" size="mini" @click="getList" type="primary">查询
        </el-button>
        <el-button type="primary" size="mini" @click="exportList">导出excel<i class="el-icon-download"></i></el-button>
      </span>

      <div class="userList-table" :style="{'height':heights+'px'}">
        <el-table ref="table" :data="tableData2" stripe style="width: 100%" :max-height="heights - 20" row-key="id"
          border>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.energyConsumptionDetailVOS" style="width: 100%"
                header-row-class-name="tableNest" class="table2" stripe border>
                <template slot="empty">
                  <span class="noData">
                    <img src="@/assets/noData.png" alt="暂无数据">
                    <span class="text">暂无数据</span>
                  </span>
                </template>
                <el-table-column label="设备名称" align="center" prop="deviceName" min-width="120" />
                <el-table-column label="上月读数" align="center" prop="lastMonNum" min-width="120" />
                <el-table-column label="本月读数" align="center" prop="nowMonNum" min-width="120" />
                <el-table-column label="本月电量" align="center" prop="electricity" min-width="120" />
                <el-table-column label="本月单价" align="center" prop="unitPrice" min-width="120" />
                <el-table-column label="本月电费" align="center" prop="cost" min-width="120" />
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="序号" type="index" align="center" width="50" />
          <el-table-column label="项目名称" align="center" prop="unitName" min-width="150" />
          <el-table-column label="租户名称" align="center" prop="userName" min-width="120" />
          <el-table-column label="租户编号" align="center" prop="userCode" min-width="140" />
          <el-table-column label="本月充值金额" align="center" prop="nowMonTopUp" min-width="120" />
          <el-table-column label="累计充值金额" align="center" prop="topUpTotal" min-width="120" />
          <el-table-column label="上月账户余额" align="center" prop="lastMonBalance" min-width="120" />
          <el-table-column label="本月账户余额" align="center" prop="nowMonBalance" min-width="120" />
        </el-table>
      </div>

      <span style="position: absolute; opacity: 0;">
        <el-table style="width: 100% " stripe :data="tableData" border id="tabled" :span-method="objectSpanMethod">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" type="index" align="center" width="50" />
          <el-table-column label="项目名称" align="center" prop="unitName" min-width="150" />
          <el-table-column label="租户名称" align="center" prop="userName" min-width="120" />
          <el-table-column label="租户编号" align="center" prop="userCode" min-width="140" />
          <el-table-column label="本月充值金额" align="center" prop="nowMonTopUp" min-width="120" />
          <el-table-column label="累计充值金额" align="center" prop="topUpTotal" min-width="120" />
          <el-table-column label="上月账户余额" align="center" prop="lastMonBalance" min-width="120" />
          <el-table-column label="本月账户余额" align="center" prop="nowMonBalance" min-width="120" />
          <el-table-column label="电表信息" align="center">
            <el-table-column label="设备名称" align="center" prop="deviceName" min-width="120" />
            <el-table-column label="上月读数" align="center" prop="lastMonNum" min-width="120" />
            <el-table-column label="本月读数" align="center" prop="nowMonNum" min-width="120" />
            <el-table-column label="本月电量" align="center" prop="electricity" min-width="120" />
            <el-table-column label="本月单价" align="center" prop="unitPrice" min-width="120" />
            <el-table-column label="本月电费" align="center" prop="cost" min-width="120" />
          </el-table-column>
        </el-table>
      </span>




    </span>
  </div>
</template>
<script>
  /* eslint-disable */
  let idTmr;
  const getExplorer=() => {
    let explorer=window.navigator.userAgent;
    //ie
    if(explorer.indexOf("MSIE")>=0) {
      return 'ie';
    }
    //firefox

    else if(explorer.indexOf("Firefox")>=0) {
      return 'Firefox';
    }
    //Chrome
    else if(explorer.indexOf("Chrome")>=0) {
      return 'Chrome';
    }
    //Opera
    else if(explorer.indexOf("Opera")>=0) {
      return 'Opera';
    }
    //Safari
    else if(explorer.indexOf("Safari")>=0) {
      return 'Safari';
    }
  }
  // 判断浏览器是否为IE
  const exportToExcel=(data,name) => {

    // 判断是否为IE
    if(getExplorer()=='ie') {
      tableToIE(data,name)
    } else {
      tableToNotIE(data,name)
    }
  }

  const Cleanup=() => {
    window.clearInterval(idTmr);
  }

  // ie浏览器下执行
  const tableToIE=(data,name) => {
    let curTbl=data;
    let oXL=new ActiveXObject("Excel.Application");

    //创建AX对象excel
    let oWB=oXL.Workbooks.Add();
    //获取workbook对象
    let xlsheet=oWB.Worksheets(1);
    //激活当前sheet
    let sel=document.body.createTextRange();
    sel.moveToElementText(curTbl);
    //把表格中的内容移到TextRange中
    sel.select;
    //全选TextRange中内容
    sel.execCommand("Copy");
    //复制TextRange中内容
    xlsheet.Paste();
    //粘贴到活动的EXCEL中

    oXL.Visible=true;
    //设置excel可见属性

    try {
      let fname=oXL.Application.GetSaveAsFilename("Excel.xls","Excel Spreadsheets (*.xls), *.xls");
    } catch(e) {
      print("Nested catch caught "+e);
    } finally {
      oWB.SaveAs(fname);

      oWB.Close(savechanges=false);
      //xls.visible = false;
      oXL.Quit();
      oXL=null;
      // 结束excel进程，退出完成
      window.setInterval("Cleanup();",1);
      idTmr=window.setInterval("Cleanup();",1);
    }
  }

  // 非ie浏览器下执行
  const tableToNotIE=(function() {
    // 编码要用utf-8不然默认gbk会出现中文乱码
    let uri='data:application/vnd.ms-excel;base64,',
      template='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table border="1">{table}</table></body></html>',
      base64=function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },

      format=(s,c) => {
        return s.replace(/{(\w+)}/g,
          (m,p) => {
            return c[p];
          })
      }
    return (table,name) => {
      let ctx={
        worksheet: name,
        table
      }

      //创建下载
      let link=document.createElement('a');
      console.log(name,'nnnnnnnn');
      link.setAttribute('href',uri+base64(format(template,ctx)));
      link.setAttribute('download',name);
      link.click();
    }
  })()

  // 导出函数
  const export2Excel=(theadData,tbodyData,dataname) => {

    let re=/http/ // 字符串中包含http,则默认为图片地址
    let th_len=theadData.length // 表头的长度
    let tb_len=tbodyData.length // 记录条数
    let width=70 // 设置图片大小
    let height=70

    // 添加表头信息
    let thead='<thead><tr>'
    for(let i=0;i<th_len;i++) {
      if(i%2==0) {
        thead+='<th colspan=2>'+theadData[i]+'</th>'
      } else {
        thead+='<th colspan=4>'+theadData[i]+'</th>'
      }

    }
    thead+='</tr></thead>'

    // 添加每一行数据
    let tbody='<tbody>'
    for(let i=0;i<tb_len;i++) {
      tbody+='<tr>'
      let row=tbodyData[i] // 获取每一行数据

      for(let key in row) {
        if(re.test(row[key])) { // 如果为图片，则需要加div包住图片
          // 
          tbody+='<td style="width:'+width+'px; height:'+height+'px; text-align: center; vertical-align: middle"><div style="display:inline"><img src=\''+row[key]+'\' '+' '+'width='+'\"'+width+'\"'+' '+'height='+'\"'+height+'\"'+'></div></td>'
        } else {
          tbody+='<td style="text-align:center">'+row[key]+'</td>'
        }
      }
      tbody+='</tr>'
    }
    tbody+='</tbody>'


    // 添加尾巴信息
    let foote='<thead><tr>'
    foote+='<th style="text-align:left" colspan=5>'+'运行情况：'+'</th>'
    foote+='<th style="text-align:left" colspan=15>'+''+'</th>'
    foote+='<th style="text-align:left" colspan=5>'+'操作者签名：'+'</th>'
    foote+='<th colspan=3>'+'  年   月   日'+'</th>'
    foote+='</tr></thead>'
    var aa=document.getElementsByTagName('thead')[1]; //头部表头
    var bb=document.getElementsByTagName('tbody')[1]; //列表内容
    let table=aa.innerHTML+bb.innerHTML;
    // 导出表格
    exportToExcel(table,dataname)
  };

  import request from "@/api/http.js";
  export default {
    data () {
      return {
        heights: document.getElementById('app').clientHeight-200,//屏幕高度 - 导航栏高度
        params: {
          nowTime: new Date(this.parseTime(new Date(),'{y}-{m}-1')).getTime(),
          queryType: 'MON', // MON,DAY
          unitId: "",
        },//请求参数
        columnArr: ["a","b","c","d","e","f"],
        spanArr: [], //临时组
        spanData: [], // 组合的合并组
        total: 0,

        pickerOptions: {//限制时间选择
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
        },
        tableData: [],
        tableData2: [{
          unitName: "抄表系统",
          userName: "珠宝店",
          userCode: "YT116",
          nowMonTopUp: 0,
          topUpTotal: 6e3,
          lastMonBalance: 2180.82,
          nowMonBalance: 1996.5,
          energyConsumptionDetailVOS: [{
            deviceName: "119",
            lastMonNum: 6516.9,
            nowMonNum: 6747.3,
            electricity: 230.4,
            unitPrice: "0.8",
            cost: 184.32
          }]
        },{
          unitName: "抄表系统",
          userName: "餐厅",
          userCode: "HT205206",
          nowMonTopUp: 1500,
          topUpTotal: 16e3,
          lastMonBalance: 820.93,
          nowMonBalance: 1278.69,
          energyConsumptionDetailVOS: [{
            deviceName: "206",
            lastMonNum: 0,
            nowMonNum: 0,
            electricity: 0,
            unitPrice: "0.8",
            cost: 0
          },{
            deviceName: "205",
            lastMonNum: 32188,
            nowMonNum: 33490.8,
            electricity: 1302.8,
            unitPrice: "0.8",
            cost: 1042.24
          }]
        },{
          unitName: "抄表系统",
          userName: "清漫",
          userCode: "403",
          nowMonTopUp: 1300,
          topUpTotal: 15200,
          lastMonBalance: 526.26,
          nowMonBalance: 1872.69,
          energyConsumptionDetailVOS: [{
            deviceName: "206",
            lastMonNum: 0,
            nowMonNum: 0,
            electricity: 0,
            unitPrice: "0.8",
            cost: 0
          },{
            deviceName: "205",
            lastMonNum: 12578,
            nowMonNum: 26478.1,
            electricity: 25542.6,
            unitPrice: "0.8",
            cost: 12584.24
          }]
        },{
          unitName: "抄表系统",
          userName: "青岛啤酒",
          userCode: "YT302",
          nowMonTopUp: 0,
          topUpTotal: 6500,
          lastMonBalance: 3250.85,
          nowMonBalance: 1568.98,
          energyConsumptionDetailVOS: [{
            deviceName: "119",
            lastMonNum: 4522.6,
            nowMonNum: 6747.3,
            electricity: 230.4,
            unitPrice: "0.8",
            cost: 184.32
          }]
        },{
          unitName: "抄表系统",
          userName: "手打柠檬茶",
          userCode: "B104",
          nowMonTopUp: 2500,
          topUpTotal: 23200,
          lastMonBalance: 576.65,
          nowMonBalance: 2572.52,
          energyConsumptionDetailVOS: [{
            deviceName: "206",
            lastMonNum: 0,
            nowMonNum: 0,
            electricity: 0,
            unitPrice: "0.8",
            cost: 0
          },{
            deviceName: "205",
            lastMonNum: 12578,
            nowMonNum: 26478.1,
            electricity: 25542.6,
            unitPrice: "0.8",
            cost: 12584.24
          }]
        }],
        all_data: [],//总数据
        loading: false,
      };
    },

    mounted () {
      this.getList();//获取列表数据  
    },
    watch: {
      nowUnit () {

        this.getList();//获取列表数据  
      }
    },
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
    },
    methods: {
      objectSpanMethod ({row,column,rowIndex,columnIndex}) {
        //    本月账户余额
        if(column.label=="项目名称"||column.label=='租户名称'||column.label=='租户编号'||column.label=='本月充值金额'||column.label=='累计充值金额'||column.label=='上月账户余额'||column.label=='本月账户余额') {
          var i=this.spanData.indexOf(rowIndex)
          if(i!=-1&&this.spanData[i+1]) {
            console.log(rowIndex,'rowIndex');
            return {
              rowspan: this.spanData[i+1]-this.spanData[i],
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      },
      //获取列表数据
      getList () {
      },

      // 时间格式化
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },
      // 下载excel
      exportList () {

        export2Excel([],[],'财务报表2023-07-28-20-00');
      },


    }
  };
</script>
<style>
  .pickerTime input {
    border: none;
  }

  input::-webkit-input-placeholder {

    font-size: 14px;

  }
</style>
<style lang="scss" scoped>
  .table2 {
    /deep/th {
      background-color: #f5f8fa !important;
      color: #000 !important;
    }
  }

  .search {
    margin-bottom: 10px;
    display: flex;
  }

  .search>span {
    display: flex;
    align-items: center;
    margin-right: 15px;
  }

  .tableHeader {
    display: flex;
    border: 1px solid;
    border-bottom: none;
    height: 48px;
    align-items: center;
  }

  .tableHeader div {
    font-size: 16px;
  }

  .tableHeader .n {
    height: 48px;
    line-height: 48px;
    border-right: 1px solid;
    width: 129px;
    text-align: center;
  }

  .home {
    box-sizing: border-box;
    background-color: #e9ebef;
    padding: 10px;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .fenye {
    display: flex;
    justify-content: flex-end;
  }
</style>